// CampaignHeader.js
import PropTypes from "prop-types";
import MoreOptions from "@/components/specific/More_Options";
import WebIcon from "@/components/common/Web_Icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteEvent } from "@/store/redux/slices/event/event_slice";
import { useLoader } from "@/hooks/LoaderProvider";
import Delete from "@/components/common/alerts/Delete";
import Button from "@/components/common/Button";

const CampaignHeader = ({ campaign, onDeleteSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useLoader();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleModifyClick = () => {
    navigate(`/dashboard/events/edit/${campaign._id}`);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setShowDeleteModal(false);
      showLoader();
      await dispatch(deleteEvent(campaign._id)).unwrap();
      hideLoader();
      onDeleteSuccess();
    } catch (error) {
      console.error("Failed to delete event:", error);
      hideLoader();
    }
  };

  // Menu items for mobile dropdown
  const mobileMenuItems = {
    items: [
      {
        key: "modify",
        label: "Modify",
        onClick: () => handleModifyClick(),
      },
      {
        key: "delete",
        label: "Delete",
        onClick: () => handleDeleteClick(),
      },
      {
        key: "share",
        label: "Share",
        // onClick: () => handleShareClick()
      },
    ],
  };

  return (
    <div className="mt-4 sm:mt-6">
      <div className="flex flex-col w-full">
        <div className="flex flex-col justify-between w-full">
          <div className="flex flex-row justify-between items-start">
            <div className="flex flex-row">
              <div className="mr-2 mt-2 border border-gray-200 rounded-md p-[8px] sm:p-[10px] aspect-square flex items-center justify-center min-w-[50px] min-h-[50px] sm:min-w-[55px] sm:min-h-[55px]">
                <WebIcon
                  icon="BlueCalendar"
                  size="large"
                  className="w-[30px] h-[30px] sm:w-[35px] sm:h-[35px]"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-left sm:text-3xl text-darkGrey">
                  {campaign.title}
                </h1>
                <p className="text-bold font-normal text-left text-black sm:text-base">
                  There are about{" "}
                  <span className="text-primary font-bold">
                    {campaign.scheduleCount} schedules
                  </span>{" "}
                  within this event
                </p>
              </div>
            </div>
            <div className="lg:hidden">
              <MoreOptions menu={mobileMenuItems} />
            </div>
            <div className="items-center hidden gap-3 lg:flex">
              <Button
                text="DELETE"
                color="outline"
                className="px-2 py-1 text-small sm:px-3 sm:py-2 sm:text-small h-8 sm:h-10 min-w-[80px] sm:min-w-[100px]"
                customBgColor=""
                customTextColor="red"
                onClick={handleDeleteClick}
              />
              <Button
                text="MODIFY"
                color="primary"
                className="px-2 py-1 text-small sm:px-3 sm:py-2 sm:text-small h-8 sm:h-10 min-w-[80px] sm:min-w-[100px]"
                customBgColor="primary"
                customTextColor="white"
                onClick={handleModifyClick}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <Delete
        isVisible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onProceed={handleConfirmDelete}
        header="Delete Event"
        paragraph={`Are you sure you want to delete the event "${campaign.title}"? This action cannot be undone.`}
        proceedButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </div>
  );
};

CampaignHeader.propTypes = {
  campaign: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    scheduleCount: PropTypes.number,
  }),
  onDeleteSuccess: PropTypes.func,
};

export default CampaignHeader;
